import { addToBatch, type LocalReaction, type ReactionBatch } from "./batch";
import {
  addPending,
  emptyPending,
  PENDING_TTL_MS,
  type OwnPending,
} from "./subtractOwn";

export interface PendingState {
  pending: OwnPending;
  /** Когда начато текущее окно ожидания своих реакций. */
  since: number;
}

export const emptyPendingState = (): PendingState => ({
  pending: emptyPending(),
  since: 0,
});

const isEmptyPending = (pending: OwnPending) =>
  Object.keys(pending.emojis).length === 0 &&
  Object.keys(pending.phrases).length === 0;

export function isPendingStale(state: PendingState, now: number): boolean {
  return now - state.since > PENDING_TTL_MS;
}

/**
 * Своё нажатие: в пачку на отправку и в ожидание вычитания. Нажатие сверх
 * лимита пачки (addToBatch вернул ту же пачку) не уходит на сервер, поэтому
 * не попадает и в ожидание: иначе вычитание съедало бы чужие реакции.
 * Окно ожидания отсчитывается от первого нажатия, частые нажатия его не
 * продлевают. null: нажатие отброшено.
 */
export function applyOwnReaction(
  batch: ReactionBatch,
  state: PendingState,
  reaction: LocalReaction,
  now: number,
): { batch: ReactionBatch; state: PendingState } | null {
  const nextBatch = addToBatch(batch, reaction);
  if (nextBatch === batch) return null;

  const restart = isEmptyPending(state.pending) || isPendingStale(state, now);
  return {
    batch: nextBatch,
    state: {
      pending: addPending(restart ? emptyPending() : state.pending, reaction),
      since: restart ? now : state.since,
    },
  };
}
